
const MQ_SIZES = {
	/*max-width: 399px*/
	S: "@media (max-width: 461px)", //phone
	M: "@media (max-width: 768px)", //tablet
	BGT: "@media (min-width: 768px)", //bigger than tablet
	D: "@media (max-width: 1220px)", //desktop
	//max-width: 1300px
	L: "@media (max-width: 1300px)", //large
	W: "@media (max-width: 1620px)", //wide
};

const getInMediaQuery = (...args) => {
	let rules = Array.isArray(args[0]) ? args :
		[[args[0], args[1]]];

	return rules.reduce((res, rule)=>{
		res[rule[0]] = rule[1];
		return res;
	}, {});
};

export {
	MQ_SIZES,
	getInMediaQuery
};
